import { Permission } from '@/hooks/usePermissions';

export enum Role {
    pending = 'pending',
    viewer = 'viewer',
    editor = 'editor',
    admin = 'admin',
    // Extended domain-specific roles
    endOfLeaseReader = 'end_of_lease_reader',
    endOfLeaseEditor = 'end_of_lease_editor',
    endOfLeaseAdmin = 'end_of_lease_admin',
    maintenanceReader = 'maintenance_reader',
    maintenanceEditor = 'maintenance_editor',
    maintenanceAdmin = 'maintenance_admin',
    maintenanceReviewReader = 'maintenance_review_reader',
    maintenanceReviewEditor = 'maintenance_review_editor',
    maintenanceReviewAdmin = 'maintenance_review_admin',
    asset360Reader = 'asset_360_reader',
    asset360Editor = 'asset_360_editor',
    asset360Admin = 'asset_360_admin',
    serviceBulletinReader = 'service_bulletin_reader',
    serviceBulletinEditor = 'service_bulletin_editor',
    serviceBulletinAdmin = 'service_bulletin_admin',
}

export type User = {
    id: string;
    username: string;
    name: string;
    roles: Role[]; // Multiple roles support
    createdAt: Date;
    updatedAt: Date;
};

export type DbUser = User & {
    id: string;
    teamId: string | null;
    twoFactorEnabledAt: Date | null;
    isLocked?: boolean;
    accountLockedAt?: Date | null;
};

export type UserProfile = DbUser & {
    permissions: Permission[];
};

export type Team = {
    id: string;
    apiKey: string;
    name: string;
    teamCode: string;
    createdAt: Date;
};

export type TeamWithMembers = Team & {
    members: DbUser[];
};

export type InviteUserRequest = {
    username: string;
    teamCode: string;
};

export interface CheckTeamsResponse {
    hasTeams: boolean;
}
